import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { AppService } from 'presentation/app.service';

@Injectable()
export class CoachSettingsGeneralBiographyController {
	public editorConfig$: Observable<any>;

	constructor(private _appService: AppService) {
		this._initObservables();
	}

	private _initObservables() {
		const locale$ = this._appService.currentLang$;

		this.editorConfig$ = locale$.pipe(
			map((language) => ({
				toolbar: ['bold', 'italic'],
				language: language,
				placeholder: 'Entrer votre biography',
			})),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}
}
